import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { loginSchema, LoginFormData } from "../../../lib/validations";
import { useLogin } from "../context/LoginContext";
import Button from "../../../components/Button";
import LoginIcon from "../../../components/Icons/LoginIcon";
import LoginInput from "../../../components/Form/LoginInput";

const LoginForm: React.FC = () => {
  const { loading, handleLogin } = useLogin();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  return (
    <form className="space-y-6" onSubmit={handleSubmit(handleLogin)}>
      <LoginInput
        label="E-mail"
        type="email"
        placeholder="seu@email.com"
        registration={register("email")}
        error={errors.email?.message}
      />

      <LoginInput
        label="Senha"
        type="password"
        placeholder="••••••••"
        registration={register("password")}
        error={errors.password?.message}
      />

      <Button
        type="submit"
        disabled={loading}
        text={loading ? "Entrando..." : "Entrar"}
        icon={<LoginIcon />}
      />

      <p className="text-center text-sm text-white/70">
        Muito mais que um sistema!
      </p>
    </form>
  );
};

export default LoginForm;
